import nomes from './situacoes.nomes'

export default Object.freeze({
    [nomes.Agendado]: { fundo: "#D4E157", texto: "#000000" },
    [nomes.AgendadoProfissional]: { fundo: "#ffff4b", texto: "#000000" },
    [nomes.AgendadoProfissionalPreferencial]: { fundo: "#DAA520", texto: "#000000" },
    [nomes.Confirmado]: { fundo: "#ff9999", texto: "#000000" },
    [nomes.Presente]: { fundo: "#66BB6A", texto: "#000000" },
    [nomes.Faltou]: { fundo: "#D8BFD8", texto: "#000000" },
    [nomes.Bloqueio]: { fundo: "#000000", texto: "#ffffff" },
    [nomes.ExecutadoPreVenda]: { fundo: "#51d0f0", texto: "#000000" },
    [nomes.ExecutadoPago]: { fundo: "#7CFC00", texto: "#000000" },
});